import { HttpRequestState } from '@app/interfaces';
import { Observable, of } from 'rxjs';
import { catchError, map, startWith } from 'rxjs/operators';

export function httpRequestState<T>() {
  return (source: Observable<T>): Observable<HttpRequestState<T>> => {
    return source.pipe(
      map((value) => ({
        isLoading: false,
        value,
        error: undefined
      })),
      startWith({
        isLoading: true,
        value: undefined,
        error: undefined
      }),
      catchError((error) =>
        of({
          isLoading: false,
          value: undefined,
          error
        })
      )
    );
  };
}
